<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click.enter="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="id" label="编号"></el-table-column>
                <el-table-column prop="page_name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="position" label="位置" show-overflow-tooltip></el-table-column>、
                <el-table-column prop="content" label="图文封面">
                    <template slot-scope="scope">
                        <div class="u-f u-ac">
                            <div v-for="(item,indexs) in scope.row.page_detail" :key="indexs">
                                <div v-for="(item,index) in item.file_info" :key="index" class="img_b">
                                    <!-- <img :src="item.url" alt="" width="50" class="tablimg"> -->
                                    <el-image style="width: 50px;height:25px" fit='cover' :src="item.url"
                                        :preview-src-list="[item.url]">
                                    </el-image>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="success" v-if="scope.row.state==1"
                            @click="is_showhandle(scope.row,0)">
                            已启用
                        </el-button>
                        <el-button size="mini" type="danger" v-else plain @click="is_showhandle(scope.row,1)">已禁用
                        </el-button>
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="广告位设置" :visible.sync="dialogVisible" center top="20px" width="50%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="forms" :rules="rule" ref="forms" label-width="150px" class="forms-lines">
                    <el-form-item label="标题" prop='name'>
                        <el-input v-model="forms.name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="位置" prop='position_code'>
                        <el-select v-model="forms.position_code" placeholder="请选择处于位置" size="small" filterable>
                            <el-option v-for="items in  wz_options" :key="items.id" :label="items.name"
                                :value="items.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <div v-for="(item,index) in forms.list" :key="index" class="">
                        <div>
                            <div>
                                <el-button type="text" @click="additem(index)">+插入项</el-button>
                            </div>
                        </div>
                        <div class="gg_box">
                            <el-form-item label="链接地址" :prop="`list.${index}.address`" :rules="rule.address">
                                <div class="u-f u-ac u-jsb">
                                    <el-input v-model="item.link" placeholder="请输入链接地址" size="small"></el-input>
                                    <div class="wtsc">
                                        <el-button icon="el-icon-delete" size="small" type="danger"
                                            @click="delxx(index)" v-if="forms.list.length>1">删除信息</el-button>
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="图片" required>
                                <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                                    :class="{disabled:item.uploadDisabled}" :headers="{ token:$store.state.user.token }"
                                    :limit="1" :data="{ image_class_id:'2',file_type:'1' }" :file-list="item.fileList"
                                    :on-success="uploadSuccess.bind(null,{'index':index,'data':item})"
                                    :on-remove="uploadRmove.bind(null,{'index':index,'data':item})"
                                    list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="问卷ID">
                                <div class="u-f u-ac u-jsb">
                                    <el-input v-model="item.wj_id" placeholder="如果是问卷调查，必填（调查问卷管理里的相应id）,其他可为‘?’后的id参数"
                                        size="small"></el-input>
                                </div>
                            </el-form-item>
                        </div>

                    </div>
                    <div class="u-f u-ac u-jsb">
                        <div></div>
                        <el-button @click="addWzxx" size="small" type="primary">新建位置</el-button>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('forms')" size="small" type="primary" :loading="subloading">确 定 </el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                eid: 0,
                dialogVisible: false,
                subloading: false,
                forms: {
                    name: '',
                    position_code: "",
                    list: [{
                        link: '',
                        wj_id: '',
                        fileList: [],
                        file_info: [],
                        uploadDisabled: false
                    }]
                },
                uploadDisabled: false,
                rule: {
                    name: [{
                        required: true,
                        message: '标题不能为空！',
                        trigger: 'blur'
                    }],
                    position_code: [{
                        required: true,
                        message: '位置不能为空！',
                        trigger: 'blur'
                    }],
                },
                wz_options: [{
                        id: 1,
                        name: '第一位置'
                    },
                    {
                        id: 2,
                        name: '第二位置'
                    },
                    {
                        id: 3,
                        name: '第三位置'
                    },
                ],


            }
        },

        mounted() {
            this.getHeight()
            this.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/AdvertisingSpace/index", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                this.eid = 0
                this.dialogVisible = true
                this.cancel()
            },
            cancel() {
                this.forms.name = ''
                this.forms.position_code = ''
                this.forms.list = [{
                    link: '',
                    wj_id: '',
                    fileList: [],
                    file_info: [],
                    uploadDisabled: false
                }]
            },
            addWzxx() {
                this.forms.list.push({
                    link: '',
                    wj_id: '',
                    fileList: [],
                    file_info: [],
                    uploadDisabled: false
                })
            },
            additem(index) {
                this.forms.list.splice(index,0,{
                    link: '',
                    wj_id: '',
                    fileList: [],
                    file_info: [],
                    uploadDisabled: false
                })
            },
            delxx(index) {
                this.forms.list.splice(index, 1)
            },
            handleEdit(row, index) {
                this.eid = row.id
                this.cancel()
                this.dialogVisible = true
                axios.post("/admin/AdvertisingSpace/read", {
                        id: row.id
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        this.forms.name = data.page_name
                        this.forms.position_code = data.position_code ? Number(data.position_code) : ''
                        data.page_detail.forEach(element => {
                            element.fileList = element.file_info
                        });
                        this.forms.list = data.page_detail
                    })
                    .catch(error => {})
            },
            is_showhandle(row, val) {
                axios
                    .post("/admin/AdvertisingSpace/updateState", {
                        id: row.id,
                        state: val
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.search()
                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {})
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var flag = true
                        this.forms.list.forEach(ele => {
                            if (ele.file_info.length < 1) {
                                flag = false
                            }
                        })
                        if (!flag) return this.$message({
                            type: 'error',
                            message: "请上传图片"
                        });
                        let position_name = this.wz_options.find(ele => {
                            return ele.id == this.forms.position_code
                        }).name
                        var urls = this.eid ? "/admin/AdvertisingSpace/update" : "/admin/AdvertisingSpace/save"
                        this.subloading = true
                        axios.post(`${urls}`, {
                                id: this.eid,
                                position_code: this.forms.position_code,
                                position: position_name,
                                page_name: this.forms.name,
                                page_detail: this.forms.list
                            }, {
                                token: true
                            })
                            .then(response => {
                                this.subloading = false
                                if (response.data.code == 200) {
                                    this.dialogVisible = false
                                    this.begin()
                                    this.$message({
                                        type: 'success',
                                        message: '操作成功'
                                    });
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: response.data.msg
                                    });
                                }
                            })
                            .catch(error => {
                                this.subloading = false
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该猜想, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/AdvertisingSpace/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 
            uploadSuccess(obj, response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                this.forms.list[obj.index].file_info.push(response.data)
                this.$set(this.forms.list[obj.index], "uploadDisabled", true)

            },
            uploadRmove(obj, file, fileList) {
                var index = this.forms.list[obj.index].file_info.findIndex(item => item.id == file.id)
                this.forms.list[obj.index].file_info.splice(index, 1)
                this.$set(this.forms.list[obj.index], "uploadDisabled", false)
            },
        }

    }
</script>

<style lang="scss" scoped>
    .gg_box {
        border: 1px dashed rgb(204, 204, 204);
        padding: 10px 0px 10px 0;
        // margin-top: 10px;
    }

    .wtsc {
        margin-right: 10px;
    }

    .disabled /deep/ .el-upload--picture-card {
        display: none;
    }

    .img_b {
        margin-right: 3px;
    }
</style>